import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import useSound from "@/hooks/useSound"; // NEW IMPORT

export default function MagneticButton({ children, className, ...props }) {
  const ref = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const { playHover, playClick } = useSound(); // SOUND HOOK

  const handleMouse = (e) => {
    const { clientX, clientY } = e;
    const { height, width, left, top } = ref.current.getBoundingClientRect();
    const middleX = clientX - (left + width / 2);
    const middleY = clientY - (top + height / 2);
    setPosition({ x: middleX * 0.2, y: middleY * 0.2 });
  };

  const reset = () => {
    setPosition({ x: 0, y: 0 });
  };

  return (
    <motion.button
      ref={ref}
      onMouseMove={handleMouse}
      onMouseEnter={() => playHover()} // SOUND
      onMouseLeave={reset}
      onMouseDown={() => playClick()} // SOUND
      animate={{ x: position.x, y: position.y }}
      transition={{ type: "spring", stiffness: 150, damping: 15, mass: 0.1 }}
      className={cn(
        "relative group inline-flex items-center justify-center rounded-full px-8 py-3 font-medium transition-colors",
        "bg-[var(--nily-teal)] text-[var(--bg-main)] shadow-[0_0_20px_var(--nily-teal)]",
        "hover:shadow-[0_0_40px_var(--nily-teal)]",
        className
      )}
      {...props}
    >
      <span className="relative z-10 flex items-center gap-2 pointer-events-none">
        {children}
      </span>
      
      <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-30 blur-md transition-opacity duration-300" />
    </motion.button>
  );
}
